/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Style imports */
import './styles.css';

/* Library imports */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from "axios";
import classNames from 'classnames'
import { GoogleLogin } from 'react-google-login';

/* Component imports */
import ContentLg from "../../ContentLg";
import LoginHeader from "../core/LoginHeader/LoginHeader";
import TopWrapper from "../core/LoginWrapper/TopWrapper";

import ConstantsLg from '../../ConstantsLg';
import Gutter from "../core/Gutter/Gutter";
import LoginFooter from "../core/LoginFooter/LoginFooter";

/*** End Imports ***/

let _cancelFbLogin = null ;
let _cancelGoogleLogin = null ;

class LoginProfessionals extends Component{
    constructor(props){
        super(props);

        this.state = {
            loginInProgress: false
        };

    }

    componentWillMount(){

    }

    onBackButtonEvent = e => {
        e.preventDefault();
        console.log(this.props);
        window.onpopstate = null
    };


    componentDidMount() {

    }

    componentWillUpdate(nextProp, nextState){
        
    }

    componentWillUnmount(){

    }

    _getBase64Image = (img_url, callBack) => {
        let img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.src = img_url;

        // Create an empty canvas element
        let canvas = document.createElement("canvas");

        let checkExist = setInterval(function() {
            if(img.naturalHeight > 0 && img.naturalWidth > 0){
                clearInterval(checkExist);
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                callBack(canvas.toDataURL("image/png"));
            }
        }, 100);
    };

    responseFacebook = (response) => {
        if(response && response.userID) {
            this.props.showAppLodingView();
            this.responseFacebookSuccessAfterLoading(response);
        }
        
    };

    responseFacebookSuccessAfterLoading = (response) => {
        // console.log("Facebook Login Success");
        // console.log(response);
        let user_info = {};
        user_info['fb_user_id'] = response.userID;
        user_info['fb_user_access_token'] = response.accessToken;
        user_info['fb_name'] = response.name;
        user_info['fb_email_address'] = response.email;
        user_info['fb_ids_for_business_list'] = response.ids_for_business.data;
        user_info['fb_profile_pic_url'] = response.picture.data.url;
        this._getBase64Image(user_info['fb_profile_pic_url'], function(profile_data_url){

            let fb_ids_for_business = '';
            const obj = user_info['fb_ids_for_business_list'];
            let listSize = Object.keys(obj).length;
            Object.keys(obj).map((key,index) =>{
                if(index === listSize-1)
                    fb_ids_for_business += obj[key].id;
                else
                    fb_ids_for_business += obj[key].id + ',' ;
            });

            const dataToSend = new FormData();
            dataToSend.append('login_type', '2');
            dataToSend.append('app_id','1');
            dataToSend.append('fb_name', user_info['fb_name']);
            dataToSend.append('fb_email_address', user_info['fb_email_address']);
            dataToSend.append('fb_user_id', user_info['fb_user_id']);
            dataToSend.append('fb_user_access_token', user_info['fb_user_access_token']);
            dataToSend.append('fb_ids_for_business', fb_ids_for_business);
            dataToSend.append('fb_profile_pic', profile_data_url);

            let CancelToken = axios.CancelToken;

            axios({
                timeout: 120 * 1000,
                method: 'post',
                url: '/loginmobile',
                withCredentials:true,
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    _cancelFbLogin = c;
                }),
                data: dataToSend
            }).then( res => {
                if(res.data.data.login_info.is_new_user == 1){
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Professional - Login Success", "Facebook Login", "New User");
                }else{
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Professional - Login Success", "Facebook Login", "Returning User");
                }

                this.onSuccessFacebookLogin(res);
            }).catch( error =>{
                console.log(error);
                this.setState({
                    loginInProgress : false
                });
            });

        }.bind(this));
    };

    responseGoogleSuccess = (response) => {
        this.props.showAppLodingView();
        this.responseGoogleSuccessAfterLoading(response);
    };
    
    responseGoogleSuccessAfterLoading = (response) => {
        
        let user_info = {};
        user_info['google_name'] = response.profileObj.name;
        user_info['google_email'] = response.profileObj.email;
        user_info['google_user_access_token'] = response.accessToken;
        user_info['google_user_id'] = response.profileObj.googleId;
        user_info['google_user_profile_pic'] = response.profileObj.imageUrl;
        let CancelToken = axios.CancelToken;
        this._getBase64Image(user_info['google_user_profile_pic'], function(profile_data_url){

            const fdata = new FormData();
            fdata.append('login_type','3');
            fdata.append('app_id','1');
            fdata.append('google_name', user_info['google_name']);
            fdata.append('google_email',user_info['google_email']);
            fdata.append('google_user_access_token',user_info['google_user_access_token']);
            fdata.append('google_user_id',user_info['google_user_id']);
            fdata.append('gl_profile_pic',profile_data_url);
            fdata.append('action_type', ConstantsLg.ACTIONS.ACTION_LOGIN_USING_GOOGLE);
            fdata.append('google_login_id_token', response.tokenId ? response.tokenId : (response.tokenObj && response.tokenObj.id_token) ? response.tokenObj.id_token : null);
            
            axios({
                timeout: 120 * 1000,
                method: 'post',
                url: ConstantsLg.ROUTE.PROF_LOGIN_BY_EMAIL,
                withCredentials:true,
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    _cancelGoogleLogin  = c;
                }),
                data: fdata

            }).then( res => {
                if(res.data.data.login_info.is_new_user == 1){
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Professional - Login Success", "Google Login", "New User");
                }else{
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Professional - Login Success", "Google Login", "Returning User");
                }
                this.onSuccessGoogleLogin();
                
            }).catch( error =>{
                console.log(error);
                //FIXME should use intercepter
                this.setState({
                    loginInProgress : false
                });
            });
        }.bind(this));
    };

    responseGoogleFailure = (response) => {
        console.log(response);
        console.log("Failure")
    };

    // ----------------------------------- listner -----------------------------------------------

    onClickCrossIcon = () => {
      this.props.onClickCrossIconForProfessional();
    };

    onClickChangeUserLoginModal = () => {
      this.props.onClickChangeUserLoginModal(ConstantsLg.LOGIN_TYPE.RECRUITER);
    };

    onClickLoginWithEmail = () => {
        this.props.onClickChangeUserLoginModal(ConstantsLg.LOGIN_TYPE.PROFESSIONAL_EMAIL_DESKTOP);
    };

    onSuccessFacebookLogin = () => {
        this.onSuccessLoginFacebook();
    };

    onSuccessLoginFacebook = () => {
        this.props.onLoginSuccessProfessional();
    };

    onSuccessGoogleLogin = () => {
        this.onSuccessLoginGoogle();
    };

    onSuccessLoginGoogle = () => {
        this.props.onLoginSuccessProfessional();
    };


    render() {
        const {toShowLoginView, responseOfGoogle} = this.props;
        
        return(
            <TopWrapper
                title = {ContentLg.SIGNUP_LOGIN}
                iconUrl = {ConstantsLg.ICONS.CROSS_ICON}
                showHeaderLftBtn = {true}
                onClickCrossIcon = {this.onClickCrossIcon}
                showHeaderRgtBtn = {true}
                rightBtnClickListener = {this.props.onClose}
            >
                <Gutter height={35} />

                <div className="lg-txt-content-body">{ContentLg.CANDIDATE_LANDING_SUB_HDR}</div>

                <Gutter height={25}/>

                <div className="lg-btns-wrpr-rect">
                    <GoogleLogin
                        clientId = {ConstantsLg.GOOGLE_CLIENT_ID}
                        render = {renderProps => (
                            <div
                                className="gl-login"
                                id = 'google-login-btn'
                                ref = {googleBtn => {this.googleBtn = googleBtn;}}
                                onClick = {renderProps.onClick}
                            >
                                <div className="google-icon">
                                    <img src={ConstantsLg.ICONS.GOOGLE_ICON_RED}/>
                                </div>
                                <div className="google-content">Continue with Google</div>
                            </div>
                          )}
                        onSuccess = {this.responseGoogleSuccess}
                        onFailure = {this.responseGoogleFailure}
                    />

                    <Gutter height={22}/>
                    {/*
                        <div 
                            className="fb-login"
                            onClick = {this.onClickLoginWithEmail}
                        >
                            <div className="facebook-icon">
                                <i class="material-icons">
                                    email
                                </i>
                            </div>
                            <div className="facebook-content">Continue with Email</div>
                        </div>
                    */}
                </div>

                <LoginFooter
                    bottomLayerContent = {ContentLg.BOTTOM_LAYER_FOR_PROFESSIONAL}
                    bottomLayerActionContent = {ContentLg.BOTTOM_LAYER_ACTION_FOR_PROFESSIONAL}
                    onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                />
            </TopWrapper>
        );
    }
}

LoginProfessionals.propTypes = {

};

LoginProfessionals.defaultProps = {

};

export default LoginProfessionals;


// WEBPACK FOOTER //
// ./src/components/ProfessionalLogin/ProfessionalLogin.js